/**
 * Gallery Slider animation.
 */
export const initGallerySliderAnimation = () => {
    document.querySelectorAll('.c-gallery-slider').forEach(gallerySlider => {
        const slides = gallerySlider.querySelectorAll('.slide');
        const indicators = gallerySlider.querySelectorAll('.indicator');
        const indicator = gallerySlider.querySelector('.indicator:first-child > .bar > div');
        const prev = gallerySlider.querySelector('.prev');
        const next = gallerySlider.querySelector('.next');
        const currentText = gallerySlider.querySelector('.current');
        const maxText = gallerySlider.querySelector('.max');

        if (!slides || !indicators || !indicator || !prev || !next || !currentText || !maxText) return;

        const slidesCount = slides.length;
        const timeout = 7000;
        let currentSlide = 0;
        let timer;

        maxText.innerHTML = String(slidesCount).padStart(2, '0');

        /**
         * Set the current slide by its index.
         *
         * @param index
         */
        const setCurrentSlide = index => {
            slides.forEach(slide => slide.classList.remove('current'));
            slides[index].classList.add('current');
        };

        /**
         * Set the current indicator position by index.
         *
         * @param index
         */
        const setCurrentIndicator = index => {
            indicator.style.setProperty('transform', `translateX(${index * 100}%)`);
        };

        // Add click listeners to indicators.
        indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => animateToSlide(index, true));
        });

        /**
         * Set the current count.
         *
         * @param index
         * @returns {string}
         */
        const setCurrentCount = index => (currentText.innerHTML = String(index + 1).padStart(2, '0'));

        /**
         * Animate to a slide by its index.
         *
         * @param index
         * @param resetInterval
         */
        const animateToSlide = (index, resetInterval) => {
            if (index === 'next') {
                currentSlide = currentSlide < slidesCount - 1 ? currentSlide + 1 : 0;
            } else if (index === 'prev') {
                currentSlide = currentSlide > 0 ? currentSlide - 1 : slidesCount - 1;
            } else {
                currentSlide = index;
            }

            setCurrentSlide(currentSlide);
            setCurrentIndicator(currentSlide);
            setCurrentCount(currentSlide);

            if (resetInterval) {
                clearInterval(timer);
                timer = setInterval(() => animateToSlide('next'), timeout);
            }
        };

        // Add click listeners to prev and next chevrons.
        prev.addEventListener('click', () => animateToSlide('prev', true));
        next.addEventListener('click', () => animateToSlide('next', true));

        let touchstartX = 0;
        let touchendX = 0;

        const handleGesture = () => {
            if (touchendX < touchstartX) animateToSlide('next', true);
            if (touchendX > touchstartX) animateToSlide('prev', true);
        };

        gallerySlider.addEventListener('touchstart', event => (touchstartX = event.changedTouches[0].screenX), false);

        gallerySlider.addEventListener(
            'touchend',
            event => {
                touchendX = event.changedTouches[0].screenX;
                handleGesture();
            },
            false
        );

        // Animate to first slide on init.
        animateToSlide(currentSlide, false);

        // Set the animation timer on init.
        timer = setInterval(() => animateToSlide('next'), timeout);
    });
};
